<script setup>
import { useRouter } from 'vue-router'

import { useSidebarStore } from '@/stores/SideBar'

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['resolve'])

const router = useRouter()
const sidebarStore = useSidebarStore()

const close = () => emit('resolve', null)

const updateLimits = () => {
  router.push('/user/limits')
  emit('resolve', 'update-limits')
}

const contactSupport = () => {
  // Executa callback opcional passado pelo pai
  if (props.options.onContactSupport) {
    props.options.onContactSupport()
  }
  sidebarStore.setSidePanel('sideContact')
  emit('resolve', 'contact-support')
}
</script>

<template>
  <ImoModal_ @close="close" headerIcon="info-circle" size="sm" title="Limite excedido">
    <template #body>
      <div class="flex flex-col items-start justify-center gap-2 py-4">
        <p class="text-neutral-60 text-sm">
          Esta operação não pode ser concluída porque ultrapassa um ou mais limites configurados.
        </p>
        <p class="text-neutral-60 text-sm">
          Para realizar transferências acima do seu limite atual, você pode solicitar um aumento de
          limite acessando as configurações do seu perfil.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="flex w-full flex-row justify-between px-4 py-2">
        <ImoTextButton
          @click="close"
          text="Voltar"
          size="sm"
          icon="undo-arrow"
          iconPosition="left"
          variant="tertiary"
        />
        <div class="flex gap-2">
          <ImoButton
            @click="contactSupport"
            text="Falar com o suporte"
            size="sm"
            variant="secondary"
            icon="messages"
          />
          <ImoButton @click="updateLimits" text="Atualizar limites" size="sm" variant="primary" />
        </div>
      </div>
    </template>
  </ImoModal_>
</template>
